export const regIdCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
// /^[\d*]{17}[0-9Xx]$/;
export const regPhone = /^1[3-9]\d{1}[\d*]{8}$/;
export const regName = /^[\u4e00-\u9fa5]{2,6}(·[\u4e00-\u9fa5]{1,6}){0,2}$/;

// 实数
export const regActualNumber = /^[+-]?(0|[1-9]\d*)(\.\d+)?$/;
// 非负实数
export const regNoNegativeActualNumber= /^\+?(0|[1-9]\d*)(\.\d+)?$/;


// 整数
export const regIntegerNumber = /^[+-]?(0|[1-9]\d*)$/;
// 正整数
export const regPositiveIntegerNumber= /^[+]?([1-9]\d*)$/;
// 非负整数
export const regNoNegativeIntegerNumber = /^[+]?(0|[1-9]\d*)$/;


// 常用正则
export const regs = {
  regName,
  regPhone,
  regIdCard,
  regActualNumber,
  regNoNegativeActualNumber,
  regIntegerNumber,
  regPositiveIntegerNumber,
  regNoNegativeIntegerNumber,
}

// 判断路径是否外联
export const isExternal = (path) => {
  return /https?/.test(path);
};



/**
 * 身份证验证
 * @param {number} type - 证件类型value（1-5）
 *  1 身份证； 2 外国人永居证； 3 港澳台居住证； 4 港澳通行证（新/旧）； 5 台湾通行证（新/旧）
 * @param {string} idNo - 证件号码
 * @returns {boolean} 验证结果
 */
export function validateIdNumber(type, idNo) {
  if (!type) return false;
  if (!idNo || typeof idNo !== 'string') return false;
  const code = idNo.trim();

  // 1 = 居民身份证
  if (type === 1) {
    return regIdCard.test(code);
  }

  // 2 = 外国人永久居留身份证（新版18位，旧版15位）
  if (type === 2) {
    const newReg = /^[A-Za-z0-9]{18}$/;
    const oldReg = /^[A-Za-z0-9]{15}$/;
    return newReg.test(code) || oldReg.test(code);
  }

  // 3 = 港澳台居民居住证（18位：8开头+17位数字）
  if (type === 3) {
    return /^8\d{17}$/.test(code);
  }

  // 4 = 港澳居民来往内地通行证（新版18位：H/M开头+17位数字 / 旧版11位：H/M开头+10位数字）
  if (type === 4) {
    const newReg = /^[HhMm]\d{17}$/;
    const oldReg = /^[HhMm]\d{10}$/;
    return newReg.test(code) || oldReg.test(code);
  }

  // 5 = 台湾居民来往大陆通行证（新版18位：T开头+17位数字 / 旧版8位纯数字）
  if (type === 5) {
    const newReg = /^[Tt]\d{17}$/;
    const oldReg = /^\d{8}$/;
    return newReg.test(code) || oldReg.test(code);
  }

  return false;
}

/**
 * 从身份证号获取性别
 * @param {string} idCard - 身份证号（18位 或 15位）
 */
export function getGenderFromIdCard(idCard='') {
  // 先去除空格，避免输入带空格
  const card = (idCard || '').trim();

  if (!card) return '';

  // 校验长度
  if (card.length !== 18 && card.length !== 15) return '';

  let genderCode;

  // 18位身份证：第17位（倒数第2位）判断性别
  if (card.length === 18) {
    genderCode = Number.parseInt(card.charAt(16), 10);
  } else {  // 15位身份证：最后一位判断性别
    genderCode = Number.parseInt(card.charAt(14), 10);
  }

  // 奇数=男，偶数=女
  return genderCode % 2 === 1 ? '男' : '女';
}


/**
 * 根据身份证获取出生日期
 * @param {string} idCard 身份证号码
 */
export function getBirthDayFromIdCard(idCard) {
  const card = (idCard || '').trim().toUpperCase();
  let birthStr = '';

  // 18位身份证
  if (card.length === 18) {
    birthStr = card.substring(6, 14);
  } else if (card.length === 15) {  // 15位老身份证
    birthStr = '19' + card.substring(6, 12);
  } else {
    return ''; // 格式错误返回空
  }

  // 拼接成 yyyy-MM-dd
  const year = birthStr.slice(0, 4);
  const month = birthStr.slice(4, 6);
  const day = birthStr.slice(6, 8);
  return `${year}-${month}-${day}`;
}
